export default {
  content: () => import("/app/layouts/content.vue").then(m => m.default || m),
  custom: () => import("/app/layouts/custom.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  dynamic: () => import("/app/layouts/dynamic.vue").then(m => m.default || m),
  "only-head": () => import("/app/layouts/onlyHead.vue").then(m => m.default || m),
  "page-index": () => import("/app/layouts/pageIndex.vue").then(m => m.default || m),
  "video-spy": () => import("/app/layouts/videoSpy.vue").then(m => m.default || m)
}